import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ReportPanel } from "@/components/ReportPanel";
import { can } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const D = "distributor_id";
const REPORTS = [
  { key: "distributor-summary", label: "Combined 3-Account", perm: "report:all", filters: [] },
  { key: "daily-dbr", label: "Daily DBR", perm: "report:all", filters: [D] },
  { key: "pnl", label: "Profit & Loss", perm: "report:all", filters: [D, "period_type"] },
  { key: "vi-margin", label: "VI Margin Calculation", perm: "report:all", filters: [D] },
  { key: "company-income", label: "Company Income: Earned vs Received", perm: "report:all", filters: [D, "category"] },
  { key: "promoter-expense", label: "Promoter Commission Expense", perm: "report:all", filters: [D] },
  { key: "expense-category", label: "Category-wise Expense", perm: "report:all", filters: [D, "category"] },
  { key: "pending-rp", label: "Pending Receivables & Payables", perm: "report:all", filters: [D] },
  { key: "capital-position", label: "Capital Position", perm: "report:all", filters: [D] },
  { key: "profit", label: "Date-wise Profit", perm: "report:all", filters: [D] },
  { key: "vi-payout", label: "VI Payment & Payout", perm: "report:all", filters: [D] },
  { key: "dse-ledger", label: "DSE-wise Ledger", perm: "report:limited", filters: [D, "dse_id"] },
  { key: "dse-wallet", label: "DSE Wallet", perm: "report:limited", filters: [D, "dse_id"] },
  { key: "vtop-transfer", label: "Retailer VTOP Transfers", perm: "report:limited", filters: [D, "dse_id", "retailer_id"] },
  { key: "retailer-ledger", label: "Retailer VTOP Ledger", perm: "report:limited", filters: [D, "retailer_id"] },
  { key: "fl-report", label: "FL Advance & Commission", perm: "report:limited", filters: [D, "fl_id"] },
  { key: "cash-bank", label: "Cash/Bank/UPI", perm: "report:all", filters: [D, "account"] },
  { key: "vi-ledger", label: "Distributor-wise VI Ledger", perm: "report:all", filters: [D] },
  { key: "party-ledger", label: "Creditors & Debtors", perm: "report:all", filters: [D, "party_id", "transaction_type"] },
  { key: "party-received", label: "Party Payment Received", perm: "report:all", filters: [D, "party_id"] },
  { key: "party-paid", label: "Party Payment Made", perm: "report:all", filters: [D, "party_id"] },
  { key: "ledger", label: "Complete Ledger & Reconciliation", perm: "report:all", filters: [D, "ledger", "dse_id", "fl_id", "payment_mode", "transaction_type"] },
];

export default function Reports() {
  const { user } = useAuth();
const PROFIT = ["distributor-summary", "pnl", "vi-margin", "company-income", "promoter-expense", "expense-category", "capital-position", "profit"];
  const list = REPORTS.filter((r) => can(user, r.perm) && (user.role === "admin" || !PROFIT.includes(r.key)));
  const [tab, setTab] = useState(list[0]?.key);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">Reports & Reconciliation</h1>
        <span className="hint-tag mt-2">Export mein wahi filtered data aata hai jo screen par dikh raha hai</span>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex-wrap h-auto">
          {list.map((r) => <TabsTrigger key={r.key} value={r.key} data-testid={`report-tab-${r.key}`}>{r.label}</TabsTrigger>)}
        </TabsList>
        {list.map((r) => (
          <TabsContent key={r.key} value={r.key} className="mt-4">
            {tab === r.key && <ReportPanel reportKey={r.key} filters={r.filters} />}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
